/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Password_PlaceholderInputs */

const en_login_password_placeholder = /** @type {(inputs: Login_Password_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter your password`)
};

const ar_login_password_placeholder = /** @type {(inputs: Login_Password_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أدخل كلمة المرور`)
};

/**
* | output |
* | --- |
* | "Enter your password" |
*
* @param {Login_Password_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "ar" }} options
* @returns {LocalizedString}
*/
export const login_password_placeholder = /** @type {((inputs?: Login_Password_PlaceholderInputs, options?: { locale?: "en" | "ar" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Password_PlaceholderInputs, { locale?: "en" | "ar" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_login_password_placeholder(inputs)
	return ar_login_password_placeholder(inputs)
});